import { IconButton } from '@monorepo/shared/componentsV2/Button/IconButton';
import { ComboboxField } from '@monorepo/shared/componentsV2/fields/ComboboxField';
import { TextField } from '@monorepo/shared/componentsV2/fields/TextField';
import { VisuallyHidden } from '@monorepo/shared/componentsV2/VisuallyHidden';
import { SelectableOption } from '@monorepo/shared/types/SelectableOption';
import { isRequired } from '@monorepo/shared/utils/validators';
import TrashIcon from '@svg/trash.svg';
import { NullableMathUnitName } from 'mapistry-shared';
import React from 'react';
import styled from 'styled-components';
import { LimitFilterFields } from './LimitFilterFields';
import { LimitType } from './types';

const DeleteButton = styled(IconButton)<{ $withLabelAdjustments: boolean }>`
  align-self: ${({ $withLabelAdjustments }) =>
    $withLabelAdjustments ? 'flex-end' : 'flex-start'};
  min-width: 2rem;
  height: 30px;
  margin-bottom: ${({ $withLabelAdjustments }) =>
    $withLabelAdjustments ? '1.6rem' : '0'};
  font-size: 0.75rem;
`;

interface LimitConditionProps {
  hideLabels: boolean;
  limitType: LimitType;
  name: string;
  onDelete?(): void;
  defaultUnit: NullableMathUnitName | undefined;
  options: SelectableOption[];
}

export function LimitCondition({
  hideLabels,
  limitType,
  name,
  onDelete,
  defaultUnit,
  options,
}: LimitConditionProps) {
  return (
    <>
      <LimitFilterFields name={name} hideLabels={hideLabels} />
      {(limitType === LimitType.min || limitType === LimitType.range) && (
        <TextField
          fullWidth
          isLabelHidden={hideLabels}
          label="Minimum"
          name={`${name}.min`}
          placeholder="n"
          required
          type="number"
          validate={isRequired}
        />
      )}
      {(limitType === LimitType.max || limitType === LimitType.range) && (
        <TextField
          fullWidth
          isLabelHidden={hideLabels}
          label="Maximum"
          name={`${name}.max`}
          placeholder="n"
          required
          type="number"
          validate={isRequired}
        />
      )}
      {!!defaultUnit && (
        <ComboboxField
          fullWidth
          isLabelHidden={hideLabels}
          label="Unit"
          name={`${name}.units`}
          options={options}
          placeholder="Unit"
          required
          validate={isRequired}
        />
      )}
      {onDelete && (
        <DeleteButton $withLabelAdjustments={!hideLabels} onClick={onDelete}>
          <VisuallyHidden>Delete condition</VisuallyHidden>
          <TrashIcon />
        </DeleteButton>
      )}
    </>
  );
}
